'use strict';

import angular from 'angular';
import SettingsController from './settings.controller';

export default angular.module('makeamapAngularApp.settings', [])
  .controller('SettingsController', SettingsController)
  .name;
